import { Image } from '@starsoft/common/components';
import { TableCoinCellProps } from './props';
import styles from './styles.module.scss';

export default function TableCoinCell({
  coin,
  size = 'medium',
  symbolOnly,
}: TableCoinCellProps) {
  return (
    <div className={styles.container}>
      <Image
        className={`${styles.container__coin} ${styles[`container__coin--${size}`]}`}
        format="square"
        width={24}
        height={24}
        src={`${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/coins/rounded/${
          coin?.image ?? 'brl.svg'
        }`}
        alt={coin?.name}
      />
      {(symbolOnly && (
        <div className={styles.container__column}>
          <div className={styles.container__column__title}>
            {coin?.code ?? 'BRL'}
          </div>
        </div>
      )) || (
        <div className={styles.container__column}>
          <div className={styles.container__column__title}>
            {coin?.name ?? 'BRL'}
          </div>
          <div className={styles.container__column__label}>
            {coin?.code ?? 'BRL'}
          </div>
        </div>
      )}
    </div>
  );
}
